import type { FC, SVGProps } from 'react';
import codexPng from './codex.png';

export const CodexIcon: FC<SVGProps<SVGSVGElement>> = ({
  className,
  style,
}) => <img src={codexPng} alt="Codex" className={className} style={style} />;
